import { AnimatePresence, m } from "motion/react";
import type { LayoutHeaderMenuDropdownColumn } from "../../../../types";
import HeaderMenuColumn from "./header-menu-column";
import { headerMenuDropdownVariant } from "./header-menu.variants";
import useHeaderState from "../use-header-state";

interface HeaderMenuDropdownProps {
  theme: "light" | "dark";
  items: LayoutHeaderMenuDropdownColumn[];
  isExpanded: boolean;
  dropdownId: number;
  dropdownLabel: string;
}

const variants = {
  enter: {
    opacity: 1,
    y: 25,
    display: "block",
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
};

type Columns = 1 | 2 | 3;

function HeaderMenuDropdown({
  theme,
  items,
  isExpanded,
  dropdownId,
  dropdownLabel,
}: HeaderMenuDropdownProps) {
  const { cancelCloseDropdown, mobile } = useHeaderState();
  const columns: Columns = (items.length as Columns) || (1 as Columns);

  const styles = headerMenuDropdownVariant({ theme, columns });

  return (
    <AnimatePresence>
      {!!isExpanded || mobile ? (
        <m.div
          animate={variants.enter}
          aria-labelledby={dropdownLabel}
          className={styles.base()}
          exit={variants.exit}
          initial={variants.exit}
          onMouseEnter={() => {
            cancelCloseDropdown();
          }}
          variants={variants}
          id={`mdiv-dropdown-id-${dropdownId}`}
        >
          <div className={styles.card()}>
            <ul className={styles.list()}>
              {items.map((column) => (
                <HeaderMenuColumn
                  theme={theme}
                  column={column}
                  key={column.id}
                />
              ))}
            </ul>
          </div>
        </m.div>
      ) : null}
    </AnimatePresence>
  );
}

export default HeaderMenuDropdown;
